import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";



export function insuranceNIFbyCountryValidator(countryCode): ValidatorFn {
    return (control:AbstractControl) : ValidationErrors | null => {
        
        const value = control.value;

        if (!value) {
            if (countryCode === 'PT' || countryCode === 'IT') {
                return { emptyValue: true }
            }
            return null;
        }
        let validInfo = true;

        if (countryCode === 'PT') {
            validInfo = /^\d{9}$/.test(value);
        } else if (countryCode === 'IT') {
            validInfo = /^\d{11}$/.test(value) || /^[A-Za-z]{6}\d{2}[A-Za-z]\d{2}[A-Za-z]\d{3}[A-Za-z]$/.test(value);
        }

        return validInfo ? null : { invalidInfo: true };
    }
}

export function insuranceAddressbyCountryValidator(countryCode): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        
        const value: string = control.value;
        if (!value) {
            if (countryCode === 'PT') {
                return { emptyValue: true }
            } 
            return null;
        }
        if (countryCode === 'PT') {
            return value.length > 5 ? null : { invalidInfo: true }
        }
        return null;
    }
}

export function insurancePostalCodebyCountryValidator(countryCode): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        const value: string = control.value;

        if (!value) {
            if (countryCode === 'PT') {
                return { emptyValue: true }
            }
            return null;
        }
        if (countryCode === 'PT') {
            const validInfo = /^\d{4}\D\d{3}$/.test(value);

            return validInfo ? null : { invalidInfo: true };
        }
        return null;
    }
}

export function insuranceCitybyCountryValidator(countryCode): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        const value = control.value;

        if (!value) {
            if (countryCode === 'PT') {
                return { emptyValue: true }
            }
            return null;
        }
        if (countryCode === 'PT') {
            const validInfo = value.length >=2 && /^[A-Za-z]+$/.test(value);

            return validInfo ? null : { invalidInfo: true };
        }
        return null;
    }
}